import React from 'react'
import Button from '../../Button'

interface ISubmitButtonProps {
  fullWidth?: boolean
  children: React.ReactNode
}

const SubmitButton = ({ children, fullWidth }: ISubmitButtonProps) => {
  return (
    <Button type="submit" variant="filled-rounded" size="small" fullWidth={fullWidth}>
      {children}
    </Button>
  )
}

SubmitButton.displayName = 'Form.SubmitButton'
export default SubmitButton
